export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/referral_program_perseus/invite.2651fd6.svg";